import { getSessionStateAPI } from "../../../../utils/session";
import { ESberPaymentStatusConstant } from "../constants";
export var getSberPayId = function getSberPayId(_ref) {
  var getWindow = _ref.getWindow;
  var sessionStateAPI = getSessionStateAPI({
    getWindow: getWindow
  });
  return {
    save: function save(value) {
      sessionStateAPI.save(ESberPaymentStatusConstant.OrderIdParameter, value);
    },
    load: function load() {
      return sessionStateAPI.get(ESberPaymentStatusConstant.OrderIdParameter);
    }
  };
};